import React from 'react'

import _modules from '../../_modules'

const Questionnaires = React.lazy(() => import('./views/questionnaires/Questionnaires'))
const QuestionnairesDetail = React.lazy(() => import('./views/questionnaires/QuestionnairesDetail'))
const QuestionnairesC = React.lazy(() => import('./views/questionnairesChart/QuestionnairesChart'))
const QuestionnaireReports = React.lazy(() =>
  import('./views/questionnaireReports/QuestionnaireReports'),
)
const QuestionnaireReportsDetail = React.lazy(() =>
  import('./views/questionnaireReports/QuestionnaireReportsDetail'),
)

const _routes = []

if (_modules.projects) {
  _routes.push(
    ...[
      {
        path: '/questionnaires/:id',
        name: 'Questionnaires Detail',
        component: QuestionnairesDetail,
      },
      { path: '/questionnaires', name: 'Questionnaires', component: Questionnaires },
      { path: '/questionnaires-chart', name: 'Questionnaires Chart', component: QuestionnairesC },

      {
        path: '/questionnaire-reports/:id',
        name: 'Questionnaire Reports Detail',
        component: QuestionnaireReportsDetail,
      },
      {
        path: '/questionnaire-reports',
        name: 'QuestionnaireReports',
        component: QuestionnaireReports,
      },
    ],
  )
}

export default _routes
